export const bar_http_period = {
  "1": "1m",
  "5": "5m",
  "15": "15m",
  "60": "1h",
  "240": "4h",
  "1D": "1d",
}
export const resolutions_reverse_template_s = {
  "1m" : "1",
  "5m" : "5",
  "15m" : "15",
  "30m" : "30",
  "1h" : "60",
  "4h" : "240",
  "1d" : "1D",
  // "1w" : "1W",
  // "1m" : "1M",
}
export const resolutions_reverse_template_sub = {
  "1min" : "1m",
  "5min" : "5m",
  "15min" : "15m",
  "30min" : "30m",
  "60min" : "1h",
  "240min" : "4h",
  "1day" : "1d",
  // "1week" : "1w",
  // "1month" : "1m",
}
export const resolutions_template = {
  "1": "1min",
  "5": "5min",
  "15": "15min",
  "30": "30min",
  "60": "60min",
  "240": "4hour",
  "1D": "1day",
  "1W": "1week",
  "1M": "1month",
}
export const resolutions_reverse_template = {
  "1min" : "1",
  "5min" : "5",
  "15min" : "15",
  "30min" : "30",
  "60min" : "60",
  "240min" : "240",
  "1day" : "1D",
  // "1week" : "1W",
  // "1month" : "1M",
}
export const sub_template = {
  "event": "sub",
	"pong": null,
	"params": {
			"channel": "",
			"cbId": "1",
			"cpId": "1",
			"mtLogin": "",
			"symbol": "usdt",
			"symbols": [],
			"kTypes": [],
	}
}
export function getNewMsg(symbol, type, event = 'sub', channel = 'kline') {
	let new_msg = sub_template
	let types = resolutions_template[type] ? resolutions_template[type] : "";
  let symbol_name = ""
  let symbol_names = ""
  // console.log("typeof symbol2=", Array.isArray(symbol))
  if (Array.isArray(symbol)) {
    symbol_names = symbol
    symbol_name = symbol[0].replace("usdt", "_usdt")
  } else {
    symbol_name = symbol.replace("usdt", "_usdt")
  }
	new_msg.event = event;
	new_msg.params.symbol = symbol_name;
	new_msg.params.symbols = symbol_names ? symbol_names : [symbol];
	// new_msg.params.symbols = [symbol];
	// new_msg.params.symbols = [symbol_name];
	new_msg.params.channel = channel;
	new_msg.params.kTypes = types ? [types] : [];
	return JSON.stringify(new_msg)
}